import styled from 'styled-components'

/*
  O país fica dentro da caixa do PhoneInput, que tem a borda e a sombra do campo inteiro. Por isso a
  caixa do Combobox perde a borda: é a parte da esquerda do mesmo campo.
*/
export const Container = styled.div`
  width: 116px;
  flex-shrink: 0;

  & [data-slot='combobox-trigger'] {
    border-color: transparent;
  }
`
